import ApiService from '@/services/api'

const state = {
  permissoes: [],
  loading: false,
  error: null
}

const mutations = {
  SET_PERMISSOES(state, permissoes) {
    state.permissoes = permissoes
  },
  
  SET_LOADING(state, status) {
    state.loading = status
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },
  
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async fetchPermissoes({ commit }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await ApiService.get('/Permissao')
      commit('SET_PERMISSOES', response.data)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Erro ao carregar permissões'
      commit('SET_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  allPermissoes: (state) => state.permissoes,
  
  permissoesCount: (state) => state.permissoes.length,
  
  isLoadingPermissoes: (state) => state.loading,
  
  permissoesError: (state) => state.error,
  
  getPermissaoById: (state) => (id) => {
    return state.permissoes.find(permissao => permissao.id === id)
  },
  
  getPermissaoByName: (state) => (name) => {
    return state.permissoes.find(permissao => 
      permissao.name?.toLowerCase() === name.toLowerCase()
    )
  },
  
  getPermissoesByTipo: (state) => (tipo) => {
    return state.permissoes.filter(permissao => permissao.tipo === tipo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}